const frequencies = {
  daily: 'every_day',
  hourly: 'every_hour',
  weekly: 'every_week',
};

const labelFrequencies = {
  daily: 'Daily',
  hourly: 'Hourly',
  weekly: 'Weekly',
};

export function serializeFrequencyLabel(frequency?: string) {
  switch (frequency) {
    case frequencies.weekly:
      return labelFrequencies.weekly;
    case frequencies.daily:
      return labelFrequencies.daily;
    case frequencies.hourly:
      return labelFrequencies.hourly;
    default:
      return null;
  }
}
